import logo from './logo.svg';
import './App.css';
import Header from './components/Header';
import About from './components/About';
import Shop from './components/Shop';
import Roadmap from './components/Roadmap';
import Perks from './components/Perks';
import Instruct from './components/Instruct';
import Themes from './components/Themes';
import Socails from './components/Socails';
import Footer from './components/Footer';
import Navigation from './components/Navigation';

function App() {
  return (
    <div className="App">
      <Navigation/>
      <Header/>
      <About/>
      <Shop/>
      
      <Roadmap/>
      <Perks/>
      
      <Themes/>
      <hr style={{marginTop:'5%'}}/>
      <Footer/>
    </div>
  );
}

export default App;